import { render, staticRenderFns } from "./AuthHero.vue?vue&type=template&id=2644a7de"
import script from "./AuthHero.vue?vue&type=script&lang=js"
export * from "./AuthHero.vue?vue&type=script&lang=js"
import style0 from "./AuthHero.vue?vue&type=style&index=0&id=2644a7de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports